import { IInferenceModel, SubscriptionTiers, useModelTierDisplayName } from "@next-platform/client-common-core";
import { Badge, BadgeVariant, Icon, IconVariants, Text, TextVariants } from "@next-platform/client-common-spicy-ui";

import { Col, Row } from "@/components/customComponents";
import { cn, getTierBadgeColors } from "@/utils";

import { IModelCardProps } from "../types";

const ModelCard = ({ model = {} as IInferenceModel, selectedModel, onChangeModel, isDisabled, readOnly, dataTestId = "" }: IModelCardProps) => {
  const { id, name, size, tokens, description, tag, level } = model;
  const tierDisplayName = useModelTierDisplayName({ level });
  const isSelected = selectedModel === id;
  const isKeepModelDisabled = !isSelected && isDisabled;

  return (
    <Row
      className={cn(
        "items-center py-md gap-md w-full hover:bg-gray-7",
        isKeepModelDisabled && "opacity-50",
        readOnly ? "cursor-default" : "cursor-pointer",
      )}
      onClick={() => onChangeModel?.(id)}
    >
      <Col className="gap-0.5" dataTestId={dataTestId}>
        <Row className="justify-between items-center gap-0.5">
          <Row className="gap-sm items-center flex-wrap">
            <Text variant={TextVariants.LABEL_LARGE_REGULAR} className="text-gray-12">
              {name}
            </Text>
            {level || tag ? (
              <Row className="gap-sm">
                {level ? (
                  <Badge showDot={false} variant={BadgeVariant.OUTLINED} className={cn(getTierBadgeColors(level as SubscriptionTiers))}>
                    {tierDisplayName}
                  </Badge>
                ) : null}
                {tag ? (
                  <Badge showDot={false} variant={BadgeVariant.OUTLINED}>
                    {tag}
                  </Badge>
                ) : null}
              </Row>
            ) : null}
          </Row>
          <Row className="gap-sm">
            <Badge showDot={false} variant={BadgeVariant.OUTLINED}>
              {size}
            </Badge>
            <Badge showDot={false} variant={BadgeVariant.OUTLINED}>
              {tokens}
            </Badge>
          </Row>
        </Row>
        <Text variant={TextVariants.LABEL_SMALL_REGULAR} className={cn("text-gray-10", readOnly && "line-clamp-2")}>
          {description}
        </Text>
      </Col>
      {!readOnly && <Icon icon={IconVariants.CHECK} className={cn("text-blue-10", !isSelected && "invisible")} />}
    </Row>
  );
};

export default ModelCard;
